/* eslint-disable react/no-array-index-key */
import { Select, SelectOption, Tooltip } from 'appkit-react';
import {
    Card, Col, Row,
} from 'react-bootstrap';

import DataLengthCheckModalContainer from '../containers/DataLengthCheckModalContainer';

const RuleAssignment = ({
    currentPageAssignedRulesData, isDataLengthCheckModalvisible, rules,
    onSelect, onSelectRuleForAssignment, selectedColumn, selectedColumnId,
    selectedRuleId, onAddDataLengthCheckDetails, onCancelDataLengthCheckDetails,
    dropdownMode, setIsDataLengthCheckModalvisible,
}) => (
    <>
        <Row xs={1} md={3} style={{ marginLeft: 0 }}>
            {currentPageAssignedRulesData && currentPageAssignedRulesData.map((col, index) => (
                <Col key={`card_${index}`} style={{ paddingLeft: 0, paddingRight: 0 }}>
                    <Card
                        style={{
                            width: 'content-fit', marginLeft: '0.5rem', marginRight: '0.5rem', paddingLeft: '0.5rem',
                        }}
                        className="mb-2"
                    >
                        <Card.Body>
                            <Card.Title>{col.columnName}</Card.Title>
                            <div>
                                {isDataLengthCheckModalvisible && (
                                    <DataLengthCheckModalContainer
                                        isDataLengthCheckModalvisible={isDataLengthCheckModalvisible}
                                        columnName={selectedColumn}
                                        columnId={selectedColumnId}
                                        ruleId={selectedRuleId}
                                        onAddDataLengthCheckDetails={onAddDataLengthCheckDetails}
                                        onCancelDataLengthCheckDetails={onCancelDataLengthCheckDetails}
                                        setIsDataLengthCheckModalvisible={setIsDataLengthCheckModalvisible}
                                    />
                                )}
                                <Select
                                    placeholder="Data Quality Config"
                                    value={currentPageAssignedRulesData[index].ruleIds}
                                    onSelect={e => { onSelect(col.columnId, e); }}
                                    name="selectedRulesForColumn"
                                    dropdownRenderMode={dropdownMode}
                                    multiple
                                    showSearchOnList
                                >
                                    {
                                        rules.data && rules.data.DQgetRules.map(rule => (
                                            <SelectOption
                                                key={rule.ruleId}
                                                value={rule.ruleId}
                                                onClick={() => onSelectRuleForAssignment(col.columnId, col.columnName, rule.ruleId, rule.ruleName)}
                                            >
                                                <Row style={{ width: '100%' }}>
                                                    <Col md={9}>
                                                        {rule.ruleName}
                                                    </Col>
                                                    <Col md={1}>
                                                        <Tooltip content={rule.ruleDescription} placement="top" tooltipTheme="light">
                                                            <span className="appkiticon icon-information-outline a-text-orange" aria-hidden="true" />
                                                        </Tooltip>
                                                    </Col>
                                                </Row>
                                            </SelectOption>
                                        ))
                                    }
                                </Select>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            ))}
        </Row>
    </>
);

export default RuleAssignment;
